module.exports = __webpack_public_path__ + "img/H.04061ced.png";